import { useEffect } from 'react';
import { CustomViewEntity, useCustomViewEntityConfig } from 'src/graphql/entities/custom-view';
import { mapSortAttributeToFormInterface } from 'src/graphql/entities/custom-view/custom-view-config/utils';
import { useCustomViewState } from 'src/pages/CustomViews/hooks/use-custom-view-state';

export const useInitDefaultBaseSelectedView = ({
  entityName,
  viewId,
  skip = false,
}: {
  entityName: CustomViewEntity;
  viewId: string;
  skip?: boolean;
}) => {
  const { columns, sort, handleColumnsUpdate, handleSortChange } = useCustomViewState({
    id: viewId,
    entity: entityName,
  });

  const { attributesList } = useCustomViewEntityConfig(entityName);

  // select default column list if no columns selected explicitly
  useEffect(() => {
    if (!skip && !columns?.length && attributesList?.length) {
      handleColumnsUpdate(attributesList.filter((i) => i.default));
    }
  }, [attributesList, columns, handleColumnsUpdate, skip]);

  // select default sorting if no sorting selected explicitly
  useEffect(() => {
    if (!skip && !sort?.accessor && attributesList?.length) {
      const defaultSortAttribute = attributesList.find((i) => i.default && i.sortingKey);

      if (defaultSortAttribute) {
        handleSortChange(mapSortAttributeToFormInterface(defaultSortAttribute));
      }
    }
  }, [attributesList, sort, handleSortChange, skip]);
};
